const initialState = {
    menu_switcher: false,
    console_switcher: false,
}
export default initialState;